<template>
    <BaseSection class="base-section base-section--full-bleed base-section--flush-bottom">
        <template
            v-if="pending || !!$slots.title"
            #title
        >
            <template v-if="pending">
                <Skeletor />
            </template>
            <slot
                v-else
                name="title"
            />
        </template>

        <div
            v-if="segments && segments.length"
            class="segmentation-tool"
        >
            <SegmentationCard
                v-for="item in segments"
                :key="item.id"
                :item
            />
        </div>
    </BaseSection>
</template>

<script setup>
defineProps({
    pending: {
        type: Boolean,
        default: false
    },
    segments: {
        type: Array,
        default: () => []
    }
});
</script>

<style lang="less">
.segmentation-tool {
    display: flex;
    justify-content: center;
    gap: var(--spacing-sm);
    max-width: 54rem;
    margin: -1rem auto 0;
    flex-wrap: wrap;

    .segmentation-card {
        flex: 0 1 calc(50% - var(--spacing-sm));
    }

    @media @q-md-min {
        margin-top: -2rem;

        .segmentation-card {
            flex: 0 1 calc(25% - var(--spacing-sm));
        }
    }
}
</style>
